export class DoorListController {

    constructor(UserSessionService, NewDoorService) {
        'ngInject';

        this.userSessionService = UserSessionService;
        this.newDoorService = NewDoorService;
    }

    $onInit() {

    }

    $onDestroy() {

    }

    $onChanges() {

    }

    getDoors() {
        return this.userSessionService.getDoors();
    }

    getSelectedDoor() {
        return this.userSessionService.getSelectedDoor();
    }

    addDoor() {
        this.newDoorService.open().then((response) => {
            this.userSessionService.addDoor({type: response});
        });
    }

    selectDoor(door) {
        this.userSessionService.setSelectedDoor(door);
    }

    removeDoor(door, $event) {
        this.userSessionService.removeDoor(door);

        if ($event.stopPropagation) $event.stopPropagation();
        if ($event.preventDefault) $event.preventDefault();
        $event.cancelBubble = true;
        $event.returnValue = false;
    }

}



// WEBPACK FOOTER //
// ./src/js/components/door-list/door-list.controller.js